import { CutCircle } from '../shapes/toolshapes/CutCircle';
import { CutRectangle } from '../shapes/toolshapes/CutRectangle';
import { CutText } from '../shapes/toolshapes/CutText';
import { MaterialCircle } from '../shapes/toolshapes/MaterialCircle';
import { MaterialRectangle } from '../shapes/toolshapes/MaterialRectangle';
import { MaterialText } from '../shapes/toolshapes/MaterialText';
import { ImportedShape } from '../shapes/ImportedShape';
import { ImportedCircle } from '../shapes/ImportedCircle';
import { ImportedEllipse} from '../shapes/ImportedEllipse';
import { CutSvg } from '../shapes/toolshapes/CutSvg';
import { MaterialSvg } from '../shapes/toolshapes/MaterialSvg';
import { CutTriangle } from '../shapes/toolshapes/CutTriangle';
import { MaterialTriangle } from '../shapes/toolshapes/MaterialTriangle';
import store from '../store';

export default {
    importShape(shape) {
        if (shape == null || shape.type == null) return null;

        switch (shape.type) {
            case 'cutcircle':
                Object.setPrototypeOf(shape, CutCircle.prototype);
                break;
            case 'cutrectangle':
                Object.setPrototypeOf(shape, CutRectangle.prototype);
                break;
            case 'cuttext':
                Object.setPrototypeOf(shape, CutText.prototype);
                break;
            case 'cutsvg':
                Object.setPrototypeOf(shape, CutSvg.prototype);
                break;
            case 'materialcircle':
                Object.setPrototypeOf(shape, MaterialCircle.prototype);
                break;
            case 'materialrectangle':
                Object.setPrototypeOf(shape, MaterialRectangle.prototype);
                break;
            case 'materialtext':
                Object.setPrototypeOf(shape, MaterialText.prototype);
                break;
            case 'materialsvg':
                Object.setPrototypeOf(shape, MaterialSvg.prototype);
                break;
            case 'materialtriangle':
                Object.setPrototypeOf(shape, MaterialTriangle.prototype);
                break;
            case 'cuttriangle':
                Object.setPrototypeOf(shape, CutTriangle.prototype);
                break;
            case 'imported':
                Object.setPrototypeOf(shape, ImportedShape.prototype);
                break;
            case 'importedcircle':
                Object.setPrototypeOf(shape, ImportedCircle.prototype);
                break;
            case 'importedellipse':
                Object.setPrototypeOf(shape, ImportedEllipse.prototype);
                break;
            default:
                throw new Error('Unknown shape type ' + shape.type);
        }
        shape.updatePath();
        return shape;
    },

    getJsonData() {
        return JSON.stringify(store.getters.shapes,
            (key, value) => {
                switch(key) {
                    case "id":
                    case "pathId":
                        return undefined;
                    default:
                        return value;
                }
            }
        );
    },

    importJsonData(jsonData) {
        store.dispatch('updateShapes', JSON.parse(jsonData));
    }
}
